import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AddressBook } from 'src/app/core/models/operations/address-book.model';
import { AddressBookService } from 'src/app/core/services/operations/address-book/address-book.service';
import { ADDRESS_BOOK_CONSTANTS } from './address-book.constants';

@Component({
  selector: 'app-address-book',
  templateUrl: './address-book.component.html',
  styleUrl: './address-book.component.scss',
  standalone: false,
})
export class AddressBookComponent {
  @Input() selectedConsignee: string = '';
  @Input() selectedAddress: string = '';
  @Input() selectedCity: string = '';
  @Input() selectedRoute: string = '';
  @Input() set triggerSearch(value: boolean) {
    if (value) {
      this.fetchAddressBook();
    }
  }

  @Output() addressSelected = new EventEmitter<AddressBook>();

  readonly CONSTANTS = ADDRESS_BOOK_CONSTANTS;
  addressBookData: AddressBook[] = [];

  readonly destroy = inject(DestroyRef);

  constructor(private readonly addressBookService: AddressBookService) {}

  fetchAddressBook(): void {
    this.addressBookService
      .getAddressBook(
        this.selectedConsignee,
        this.selectedAddress,
        this.selectedCity,
        this.selectedRoute,
      )
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((data) => {
        this.addressBookData = data?.response;
      });
  }

  onRowClick(entry: AddressBook) {
    this.addressSelected.emit(entry);
  }
}
